import ls from 'local-storage'
import jwtDecode from 'jwt-decode'
import store from '../store'
import axios from '../../utils/axios'

export const AUTH_BEGIN = 'AUTH_BEGIN'
export const AUTH_ERROR = 'AUTH_ERROR'

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGOUT = 'LOGOUT'

export const getToken = data => {
  const config = store.getState().global.config
  const body = {
    grant_type: 'authorization_code',
    code: data.code,
    client_id: config.clientId,
    redirect_uri: (window.location.host.includes('localhost')) ? `http://${window.location.host}/login/callback` : `https://${window.location.host}/login/callback`,
    code_verifier: data.codeChallenge
  }
  const axiosConfig = {
    method: 'post',
    url: `${config.authBaseUrl}/token`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Accept: 'application/json'
    },
    data: Object.keys(body).map(key => key + '=' + body[key]).join('&')
  }
  return (dispatch, getState) => {
    return axios(axiosConfig)
      .then((response) => {
        const userData = jwtDecode(response?.data?.access_token)
        userData.initials = userData?.given_name?.charAt(0) + userData?.family_name?.charAt(0)
        ls('token', response.data.access_token)
        ls('id_token', response.data.id_token)
        ls('refresh_token', response.data.refresh_token)
        dispatch(loginSuccess(userData))
      })
      .catch(() => {
        // if getting the token fails for any reason - logout of the app
        dispatch(logOutOkta())
      })
  }
}

export const GetFCOktaToken = () => {
  const config = store.getState().global.config
  const axiosConfig = {
    method: 'get',
    baseURL: config.baseURL,
    url: '/package/fcoktatoken',
    headers: {
      'Content-Type': 'application/json',
    }
  }

  return (dispatch) => {
    return axios(axiosConfig)
      .then((response) => {
        if (response.data.Token) {
          ls('fc_okta_token', response.data.Token)
          const tokenDecoded = jwtDecode(ls('fc_okta_token'))
          let expiry = tokenDecoded.exp
          expiry = new Date(expiry * 1000)
          const expTime = expiry.getTime() - new Date().getTime() - 60000
          setTimeout(() => {
            dispatch(GetFCOktaToken())
          }, expTime)
        }
      })
      .catch(error => {
        console.log(`Final Scan error is: ${error.message}`)
      })
  }
}

export const refreshToken = () => {
  const config = store.getState().global.config
  const refreshToken = ls('refresh_token')
  const body = {
    grant_type: 'refresh_token',
    redirect_uri: (window.location.host.includes('localhost')) ? `http://${window.location.host}/login/callback` : `https://${window.location.host}/login/callback`,
    refresh_token: refreshToken,
    client_id: config.clientId,
    scope: 'offline_access+openid+profile'
  }
  const axiosConfig = {
    method: 'POST',
    url: `${config.authBaseUrl}/token`,
    headers: {
      'Cache-Control': 'no-cache',
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: Object.keys(body).map(key => key + '=' + body[key]).join('&')
  }
  return (dispatch, getState) => {
    return axios(axiosConfig)
      .then((response) => {
        const userData = jwtDecode(response?.data?.access_token)
        userData.initials = userData?.given_name?.charAt(0) + userData?.family_name?.charAt(0)
        ls('token', response.data.access_token)
        ls('id_token', response.data.id_token)
        ls('refresh_token', response.data.refresh_token)
        dispatch(loginSuccess(userData))
      })
      .catch((error) => {
        dispatch(authError((error?.response?.data?.message) ? error.response.data.message : error.message))
      })
  }
}

export const logOutOkta = () => {
  const config = store.getState().global.config
  const postLogoutRedirectUri = window.location.origin + '/logged-out'
  const idToken = ls('id_token')
  const logoutUrl = `${config.authBaseUrl}/logout?id_token_hint=${idToken}&post_logout_redirect_uri=${postLogoutRedirectUri}`
  const numberOfCalls = localStorage.getItem('NumberOfCalls')
  const longest = localStorage.getItem('Longest')
  const quickest = localStorage.getItem('Quickest')
  const totalTime = localStorage.getItem('TotalTime')
  const average = localStorage.getItem('Average')
  const scanTimes = localStorage.getItem('ScanTimes')
  const lastClearDate = localStorage.getItem('LastClearDate')
  ls.clear()
  if (numberOfCalls !== null) {
    localStorage.setItem('NumberOfCalls', numberOfCalls)
  }
  if (longest !== null) {
    localStorage.setItem('Longest', longest)
  }
  if (quickest !== null) {
    localStorage.setItem('Quickest', quickest)
  }
  if (totalTime !== null) {
    localStorage.setItem('TotalTime', totalTime)
  }
  if (average !== null) {
    localStorage.setItem('Average', average)
  }
  if (scanTimes !== null) {
    localStorage.setItem('ScanTimes', scanTimes)
  }
  if (lastClearDate !== null) {
    localStorage.setItem('LastClearDate', lastClearDate)
  }
  window.location = logoutUrl

  return (dispatch, getState) => {
    dispatch(startLogout())
  }
}

// AUTH
export const authBegin = () => {
  return {
    type: AUTH_BEGIN
  }
}

export const authError = error => {
  return {
    type: AUTH_ERROR,
    error
  }
}

// LOGIN
export const loginSuccess = (user = {}) => {
  return {
    type: LOGIN_SUCCESS,
    user
  }
}

// LOGOUT
export const logout = () => {
  return {
    type: LOGOUT
  }
}

export const startLogout = () => {
  const numberOfCalls = localStorage.getItem('NumberOfCalls')
  const longest = localStorage.getItem('Longest')
  const quickest = localStorage.getItem('Quickest')
  const totalTime = localStorage.getItem('TotalTime')
  const average = localStorage.getItem('Average')
  const scanTimes = localStorage.getItem('ScanTimes')
  const lastClearDate = localStorage.getItem('LastClearDate')
  ls.clear()
  if (numberOfCalls !== null) {
    localStorage.setItem('NumberOfCalls', numberOfCalls)
  }
  if (longest !== null) {
    localStorage.setItem('Longest', longest)
  }
  if (quickest !== null) {
    localStorage.setItem('Quickest', quickest)
  }
  if (totalTime !== null) {
    localStorage.setItem('TotalTime', totalTime)
  }
  if (average !== null) {
    localStorage.setItem('Average', average)
  }
  if (scanTimes !== null) {
    localStorage.setItem('ScanTimes', scanTimes)
  }
  if (lastClearDate !== null) {
    localStorage.setItem('LastClearDate', lastClearDate)
  }
  return (dispatch, getState) => {
    dispatch(logout())
  }
}
